// extracted by mini-css-extract-plugin
export default {"box":"style_box__3x2SA","back":"style_back__wF9Qi","container":"style_container__fAqPZ","active":"style_active__gf242"};